import React from "react";
import Navigation from "../Navbar";
import Footer from "../Footer";
import Week3pdf from "./week3.pdf";

const Week3 = () => {
  return (
    <div className="min-h-screen bg-white">

      {/* Navbar */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Navigation />
      </div>

      <main className="pt-[170px] px-6 md:px-16 pb-16">

        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-blue-900">
            CM Health Fellows:
            <span className="text-orange-600">
              A Replicable Human Resource for Health (HRH)
              <br />
              Reform Model for Hard-to-Reach India
              <br />
              <span className="text-2xl text-blue-900 font-semibold">
                By : Dr. Rajiv Chhibber, Aditya P. Arya
              </span>
            </span>
          </h1>
        </div>

        {/* PDF Viewer */}
        <div
          className="w-full h-[900px] border rounded-xl shadow-lg overflow-hidden"
          onContextMenu={(e) => e.preventDefault()}
        >
          <embed
            src={`${Week3pdf}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
            type="application/pdf"
            width="100%"
            height="100%"
          />
        </div>

      </main>

      <Footer />
    </div>
  );
};

export default Week3;